import { Component, Input, ViewChild } from '@angular/core';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { RegularizationService } from '../Model/Regularization/regularization.service';
import { SessionService } from '../Util/Session/session.service';
import { CommonService } from '../Model/Common/common.service';
import { ToastService, toastTypeEnum } from '../Util/Toast/toast.service';
import { CustomDateParserFormatter } from '../Util/DateFormat/date-format.service';
import { NgbAlertModule, NgbDateParserFormatter, NgbDatepickerModule, NgbDropdownModule, NgbModal, NgbNavModule, NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { UtilityService } from '../Model/utility/utility.service';
import { TooltipService } from '../Util/Tooltip/tooltip.service';
import moment from 'moment';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AsyncPipe, CommonModule, DecimalPipe, JsonPipe } from '@angular/common';
import { RouterModule, RouterOutlet } from '@angular/router';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { ApprovalTrackingComponent } from '../Component/ApprovalTracking/approval-tracking/approval-tracking.component';
import { ConfirmationComponent } from '../Component/Confirmation/confirmation/confirmation.component';
import { AlertSuccessComponent } from '../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../Component/Alert/alert-warning/alert-warning.component';
import { AdminRegularizationApprovalComponent } from '../admin-regularization-approval/admin-regularization-approval.component';
import { AdminRegularizationFormComponent } from '../admin-regularization-form/admin-regularization-form.component';
import { AdminRegularizationRequestComponent } from '../admin-regularization-request/admin-regularization-request.component';

interface RegularizationHistory {
  RegularizationAttendanceDetailsID: number,
  EmpMasterId: number;
  AttendanceStatus: string;
  AttendanceDate: string;
  InTime: string;
  OutTime: string;
  ApprovalStatus: string;
  InReason: string;
  OutReason: string;
  TransactionId: number;
  Photo: string;
  EmployeeName: string;
  EmpCode: string;
  DesignationName: string;
  ClientLocation: string;
  BranchName: string;
}

@Component({
  selector: 'app-admin-regularization-history',
  standalone: true,
  imports: [NgbNavModule, NgbDatepickerModule, FormsModule, JsonPipe, NgbAlertModule, NgbTimepickerModule, CommonModule, DecimalPipe, AsyncPipe, DataTablesModule, ReactiveFormsModule, NgbDropdownModule, RouterOutlet, RouterModule, LoaderComponent],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
  templateUrl: './admin-regularization-history.component.html',
  styleUrl: './admin-regularization-history.component.scss'
})
export class AdminRegularizationHistoryComponent {

  @Input() EmployeeId = 0;
  @Input() EmpType = '';

  isDisabled: boolean = false;
  user = [] as any;

  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  RegularizationDatas: RegularizationHistory[] = [];

  Filter = {
    ModuleMasterId: 4,
    FromDate: null as any,
    ToDate: null as any,
    ApprovalStatus: 'ALL',
    IsWithdraw: false,
  }
  dtoptions: DataTables.Settings = {};
  constructor(
    private regularization: RegularizationService,
    private session: SessionService,
    protected common: CommonService,
    public toast: ToastService,
    public dateFormate: CustomDateParserFormatter,
    private modalService: NgbModal,
    private utility: UtilityService,
    private dateFormat: CustomDateParserFormatter,
    private tooltip: TooltipService
  ) {
    // this.common.getPageRights();
    this.user = this.session.GetUserDetails();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.user.UserId = this.EmployeeId;
    this.user.EmpType = this.EmpType;
    this.SelectDate('RegistrationDate', null, null);
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  Validate(form: any) {
    if (form.valid) {
      this.Search();
    } else {
      form.submitted = true;
    }
  }

  Search() {
    if (this.Filter.IsWithdraw) {
      this.RegularizationAttendanceDetails();
    } else {
      this.LoadRegularizationMaster();
    }
  }

  LoadRegularizationMaster() {
    if (moment(this.dateFormat.format(this.Filter.ToDate), 'DD MMM YYYY').isSameOrAfter(moment(this.dateFormat.format(this.Filter.FromDate), 'DD MMM YYYY'))) {
      this.regularization.RegularizationAttendanceDetails({ SelectType: 1, EmpMasterId: this.user.UserId, FromDate: this.dateFormat.format(this.Filter.FromDate), ToDate: this.dateFormat.format(this.Filter.ToDate), ApprovalStatus: this.Filter.ApprovalStatus }).subscribe({
        next: (response) => {
          this.RegularizationDatas = response;
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
        },
        complete: () => { },
        error: (error) => { },
      });
    } else {
      this.toast.show({ message: this.tooltip.Message.FromDateToDateMessgae, type: toastTypeEnum.danger });
    }
  }

  RegularizationAttendanceDetails() {
    this.isDisabled = true;
    this.regularization.RegularizationAttendanceDetails({ SelectType: 3, EmpMasterID: this.user.UserId, }).subscribe({
      next: (response) => {
        this.RegularizationDatas = response;
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Tracking(Id: number) {
    const modalRef = this.modalService.open(ApprovalTrackingComponent, { size: 'lg' });
    modalRef.componentInstance.Detail.ModuleMasterId = this.Filter.ModuleMasterId;
    modalRef.componentInstance.Detail.EmpMasterId = this.RegularizationDatas.filter((e: any) => e.TransactionId == Id)[0]['EmpMasterId'];
    modalRef.componentInstance.Detail.TransactionId = this.RegularizationDatas.filter((e: any) => e.TransactionId == Id)[0]['TransactionId'];
    modalRef.componentInstance.Detail.UserImage = this.common.PhotoLink(this.RegularizationDatas.filter((e: any) => e.TransactionId == Id)[0]['Photo']);
    modalRef.componentInstance.Detail.EmployeeName = this.RegularizationDatas.filter((e: any) => e.TransactionId == Id)[0]['EmployeeName'];
    modalRef.componentInstance.Detail.EmpCode = this.RegularizationDatas.filter((e: any) => e.TransactionId == Id)[0]['EmpCode'];
    modalRef.componentInstance.Detail.DesignationName = this.RegularizationDatas.filter((e: any) => e.TransactionId == Id)[0]['DesignationName'];
    modalRef.result.then(result => { });
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    this.isDisabled = true;
    this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          this.Filter.FromDate = this.dateFormat.parse(response.Table[0].RegistrationDate);
          this.Filter.ToDate = this.dateFormat.parse(response.Table[0].RegistrationDate);

          this.Filter.FromDate.day = 1;
          this.Filter.ToDate.day = parseInt(moment(response.Table[0].RegistrationDate).endOf('month').format('D'));
        }
        this.Search();
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Clear() {
    this.RegularizationDatas = [];
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }

  SaveRegularizationAttendance(index: number) {
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to withdraw?';
    modalRef.result.then(result => {
      if (result) {
        this.isDisabled = true;
        this.regularization.SaveRegularizationAttendance({ SelectType: 'WITHDRAWN', RegularizationAttendanceID: this.RegularizationDatas[index]['RegularizationAttendanceDetailsID'],
        IsAdminWithdrawn: true,
        AdminWithdrawnRequestBy: this.user.UserId,
         }).subscribe({
          next: (response) => {
            if (response.Error_Code == '697') {
              const modalRef = this.modalService.open(AlertSuccessComponent, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'confirmation-modal'
              });
              modalRef.componentInstance.Message = response.Error_Message;
              modalRef.result.then((result: any) => {
                if (result) {
                  this.Search();
                }
              });
            } else {
              const modalRef = this.modalService.open(AlertWarningComponent, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'confirmation-modal'
              });
              modalRef.componentInstance.Message = response.Error_Message;
              modalRef.result.then((result: any) => { });
            }
            this.isDisabled = false;
          },
          complete: () => { },
          error: (error) => {
            this.isDisabled = false;
          },
        });
      }
    });
  }

  openRegularizationDetails(EmpMasterID: any, RegularizationAttendanceDetailsID: any) {
    const modalRef = this.modalService.open(AdminRegularizationApprovalComponent, { centered: true, backdrop: 'static', size: 'xl' });
    modalRef.componentInstance.EmployeeId = EmpMasterID;
    modalRef.componentInstance.RegularizationAttendanceDetailsID = RegularizationAttendanceDetailsID;
    modalRef.componentInstance.EmpType = this.EmpType;

    modalRef.result.then((result) => {
      if (result) {
        this.LoadRegularizationMaster();
      }
    },
      (reason) => {
        console.log('Modal dismissed:', reason);
      }
    );
  }

  requestRegularization() {
    const modalRef = this.modalService.open(AdminRegularizationRequestComponent, { centered: true, backdrop: 'static', size: 'xl' });
    modalRef.componentInstance.EmployeeId = this.EmployeeId;
    modalRef.componentInstance.EmpType = this.EmpType;

    modalRef.result.then((result) => {
      if (result) {
        this.LoadRegularizationMaster();
      }
    },
      (reason) => {
        console.log('Modal dismissed:', reason);
      }
    );
  }

}